/**
 * Which floor the public room page shows.
 *
 * The room's own floor wins; the floor resolved from its apartment is the
 * fallback. Blank counts as unset at both levels, matching `get_room_floor`
 * exactly — a `??` chain does not, because `"  "` is neither null nor
 * undefined, so it would beat a perfectly good apartment floor and then trim
 * away to nothing, hiding a floor the resolver had found.
 */
export function pickEffectiveFloor(
  roomFloor: string | null | undefined,
  resolvedFloor: string | null | undefined
): string {
  return (roomFloor ?? "").trim() || (resolvedFloor ?? "").trim();
}
